var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C4.65625 6 4 6.6875 4 7.5V16.5C4 17.3438 4.65625 18 5.5 18H9.625C9.8125 18 10 17.8438 10 17.625V17.375C10 17.1875 9.8125 17 9.625 17H5.5C5.21875 17 5 16.7812 5 16.5V7.5C5 7.25 5.21875 7 5.5 7H9.625C9.8125 7 10 6.84375 10 6.625V6.375C10 6.1875 9.8125 6 9.625 6H5.5ZM14.2188 6.625L13.9688 6.84375C13.8438 7 13.8438 7.21875 13.9688 7.375L18.0938 11.4688H9.375C9.15625 11.4688 9 11.6562 9 11.8438V12.1562C9 12.375 9.15625 12.5312 9.375 12.5312H18.0938L14 16.6562C13.8438 16.8125 13.8438 17.0312 14 17.1875L14.2188 17.4062C14.3438 17.5625 14.5938 17.5625 14.75 17.4062L19.875 12.2812C20.0312 12.125 20.0312 11.9062 19.875 11.75L14.75 6.625C14.5938 6.46875 14.3438 6.46875 14.2188 6.625Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.92c40678.svg";
export { ForwardRef as ReactComponent };